import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal__container" }
const _hoisted_2 = {
  key: 0,
  class: "modal__section"
}
const _hoisted_3 = { class: "modal__section-title" }
const _hoisted_4 = { class: "modal__table" }
const _hoisted_5 = { class: "modal__table__row" }
const _hoisted_6 = { class: "modal__table__header" }
const _hoisted_7 = { class: "modal__table__cell" }
const _hoisted_8 = {
  key: 1,
  class: "modal__section"
}
const _hoisted_9 = { class: "modal__section-title" }
const _hoisted_10 = { class: "modal__table" }
const _hoisted_11 = { class: "modal__table__row" }
const _hoisted_12 = { class: "modal__table__header" }
const _hoisted_13 = { class: "modal__table__cell" }

import { i18n } from '@/i18n';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { FetchExcelModal } from '@/registerInputModule/pages/interfaces/translateExcelStore';
import { ref, watch } from 'vue';
import { DISPLAY_FORECAST_PERIOD } from '@/registerInputModule/constants/importExcelConstants';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultRegisteredAnnounceModal',
  props: {
    state: {}
  },
  emits: ["onNext"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "1e339f71": (maxTableSupplierNameColumnWidthValue.value),
  "56bb664e": (_unref(DISPLAY_FORECAST_PERIOD)),
  "f18f49fa": (maxTableNumberColumnWidthValue.value)
}))

const t = i18n.t;

const props = __props;

const emits = __emit;

// YYYYMMの文字列を作成
const monthTexts = Array.from({ length: DISPLAY_FORECAST_PERIOD }, (_, num) =>
  DateService.convertIYearMonthToYYYYMMWithSlash(DateService.getShiftedIYearMonthFromNowDateByMonths(num), true)
);

const maxTableNumberColumnWidthValue = ref('');
const maxTableSupplierNameColumnWidthValue = ref('');

/**
 * テキストが省略されないための最小幅を計算する関数
 * @param text - テキスト
 * @returns 計算結果の最小幅（ピクセル）
 */
const calculateMinWidth = (text: string): number => {
  // テキストがなければ 0 を返す
  if (!text) return 0;

  // 仮要素を作り、実際の文字幅を取得する
  // modal__table__cellを適用する
  const hiddenElement = document.createElement('span');
  hiddenElement.style.position = 'absolute';
  hiddenElement.style.visibility = 'hidden';
  hiddenElement.style.whiteSpace = 'nowrap';
  hiddenElement.textContent = text;
  hiddenElement.classList.add('modal__table__cell');

  document.body.appendChild(hiddenElement);
  const width = hiddenElement.offsetWidth;
  document.body.removeChild(hiddenElement);

  return width;
};

/**
 * 列幅を最も大きいものに合わせて計算する関数
 * @param widthList - 各値の列幅
 */
const calculateColumnWidth = (widthList: number[]) => Math.max(0, ...widthList);

watch(
  () => props.state.isOpenResultRegisteredAnnounceModal,
  () => {
    if (props.state.isOpenResultRegisteredAnnounceModal) {
      const sumAmountColumnWidth = calculateColumnWidth(
        props.state.resultRegisteredAnnounces.flatMap((business) =>
          business.sumAmountMonthly.concat(business.sumAmountDaily).map((sumAmount) => calculateMinWidth(sumAmount.addComma()))
        )
      );
      const supplierNameColumnWidth = calculateColumnWidth(
        props.state.resultRegisteredAnnounces.map((business) => calculateMinWidth(business.supplierName))
      );
      const spacing = 20;
      maxTableNumberColumnWidthValue.value = `${sumAmountColumnWidth + spacing}px`;
      maxTableSupplierNameColumnWidthValue.value = `${supplierNameColumnWidth + spacing}px`;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.state.isOpenResultRegisteredAnnounceModal,
    "next-button-label": _unref(t)('次へ'),
    "enable-outside-click": false,
    onOnNext: _cache[0] || (_cache[0] = ($event: any) => (emits('onNext')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('内示登録結果')), 1)
    ]),
    description: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(t)('登録に成功した内示数量の結果です。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.state.importFlags['内示'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('月別内示')), 1),
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("tr", _hoisted_5, [
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)('仕入れ先名')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthTexts), (monthText, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: `monthly-${index}-header`,
                      class: "modal__table__header"
                    }, _toDisplayString(monthText), 1))
                  }), 128))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.resultRegisteredAnnounces, (business) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `monthly-${business.supplierName}`,
                    class: "modal__table__row"
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(business.supplierName), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(business.sumAmountMonthly, (sumAmount, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: `monthly-${index}-data`,
                        class: "modal__table__cell modal__table__cell--number"
                      }, _toDisplayString(sumAmount.addComma()), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.importFlags['日別内示'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('日別内示')), 1),
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("tr", _hoisted_11, [
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(t)('仕入れ先名')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthTexts), (monthText, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: `daily-${index}-header`,
                      class: "modal__table__header"
                    }, _toDisplayString(monthText), 1))
                  }), 128))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.resultRegisteredAnnounces, (business) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `daily-${business.supplierName}`,
                    class: "modal__table__row"
                  }, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(business.supplierName), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(business.sumAmountDaily, (sumAmount, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: `daily-${index}-data`,
                        class: "modal__table__cell modal__table__cell--number"
                      }, _toDisplayString(sumAmount.addComma()), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "next-button-label"]))
}
}

})